module.exports = __webpack_public_path__ + "img/Y2K.3c374780.jpg";